import { useState } from 'react';

export default function DataNascimentoInput({ value = '', onChange, required = false }) {
  const [type, setType] = useState(value ? 'date' : 'text');

  return (
    <input
      type={type}
      className="input"
      placeholder="Data de Nascimento"
      value={value}
      onChange={onChange}
      onFocus={() => setType('date')}
      onBlur={(e) => { if (!e.target.value) setType('text'); }}
      inputMode="numeric"
      required={required}
      aria-label="Data de Nascimento"
    />
  );
}
